import { Beaker, Brain, Apple, Dumbbell, Activity, Heart } from "lucide-react";
import { useTranslation } from "react-i18next";

const MethodSection = () => {
  const { t } = useTranslation();
  const pillars = [
    { icon: Beaker,   title: t("method.p1_title"), description: t("method.p1_desc") },
    { icon: Apple,    title: t("method.p2_title"), description: t("method.p2_desc") },
    { icon: Activity, title: t("method.p3_title"), description: t("method.p3_desc") },
    { icon: Heart,    title: t("method.p4_title"), description: t("method.p4_desc") },
    { icon: Dumbbell, title: t("method.p5_title"), description: t("method.p5_desc") },
    { icon: Brain,    title: t("method.p6_title"), description: t("method.p6_desc") },
  ];

  return (
    <section
      id="method"
      data-testid="method-section"
      className="section-padding relative overflow-hidden"
      style={{ background: "#2C3524" }}
    >
      <div
        className="absolute top-0 right-0 w-1/2 h-full opacity-20 pointer-events-none"
        style={{
          background: "radial-gradient(circle at top right, #C5A059 0%, transparent 70%)",
        }}
      />

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="max-w-3xl mb-20">
          <span className="overline mb-4 block text-[#DCC286]">{t("method.overline")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-6xl text-white leading-[1.1] mb-8">
            {t("method.titlePart1")}<br />
            <span className="text-[#DCC286] italic">{t("method.titlePart2")}</span>
          </h2>
          <p className="text-white/80 text-lg md:text-xl font-light leading-relaxed">
            {t("method.intro")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 rounded-3xl overflow-hidden">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="bg-[#2C3524] p-8 md:p-10 hover:bg-[#3F4B34] transition-all duration-500 group"
              data-testid={`pillar-${index}`}
            >
              <div className="mb-6 flex items-center justify-between">
                <div className="w-14 h-14 rounded-full bg-[#C5A059]/10 flex items-center justify-center group-hover:bg-[#C5A059]/20 transition-colors">
                  <pillar.icon className="w-6 h-6 text-[#DCC286]" strokeWidth={1.5} />
                </div>
                <span className="text-[#DCC286]/50 text-sm tracking-[0.15em]">
                  0{index + 1}
                </span>
              </div>
              <h3 className="font-heading text-2xl text-white mb-3">
                {pillar.title}
              </h3>
              <p className="text-white/70 font-light text-sm leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 max-w-3xl">
          <p className="font-heading text-xl md:text-2xl text-white/90 leading-relaxed italic">
            {t("method.quote")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default MethodSection;
